/*
  画面下のダウンロードフローティングの表示を切り替える動作です。
  TOPのファーストビュー内にあるときはフローティングが邪魔だなと思ったのでつけました。
  もしかするとTOPしか使わないかもしれないですね。

  パ
*/

import 'intersection-observer';
import IntersectionObserver from 'intersection-observer-polyfill/dist/IntersectionObserver.js';
import buildThresholdsList from '../utils/buildThresholdsList';

export default class Floating {
  constructor() {
    this.firstview = document.querySelector('#firstview');
    this.pageTitle = document.querySelector('.l-page-title');
    this.floating = document.querySelector('.p-dl-flt');
    this.pageTopBtn = document.querySelector('.page-top-button');
    this.footer = document.querySelector('.l-footer');
    this.footerNoShowFlag = false

    this.currentWidth = window.innerWidth;

    this.io = new IntersectionObserver(
      this.onIntersect.bind(this),
      {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: buildThresholdsList(10)
      }
    )

    this.io2 = new IntersectionObserver(
      this.onIntersect2.bind(this),
      {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: buildThresholdsList(10)
      }
    )

    this.io.observe(this.firstview||this.pageTitle);
    this.io2.observe(this.footer);

    // UA change app btn
    this.getUa();
  }

  onIntersect(entries) {
    if (entries[0].intersectionRatio <= 0) {
      this.floating.classList.remove('is-hidden');

      if (this.footerNoShowFlag) {
        this.pageTopBtn.classList.add('isShow');
      }
    }
    if (entries[0].intersectionRatio > 0) {
      this.pageTopBtn.classList.remove('isShow');
      this.floating.classList.add('is-hidden');
    }
  }

  onIntersect2(entries) {
    if (entries[0].intersectionRatio <= 0) {
      this.footerNoShowFlag = true
      this.pageTopBtn.classList.add('isShow');
    }
    if (entries[0].intersectionRatio > 0) {
      this.footerNoShowFlag = false
      this.pageTopBtn.classList.remove('isShow');
    }
  }

  getUa() {
    let ua = navigator.userAgent,
        hideBtn;
    if (ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0 || ua.indexOf('iPad') > 0) {
      this.floating.classList.add('only-one');

      if(ua.indexOf('iPhone') > 0 || ua.indexOf('iPad') > 0) {
        hideBtn = 'android';
      } else if(ua.indexOf('Android') > 0) {
        hideBtn = 'iphone';
      }

      this.hideBtn(hideBtn)
    }
  }

  hideBtn(hideBtn) {
    document.querySelector('.p-dl-flt__store[data-store="'+ hideBtn + '"]').style.display = 'none';
  }
}
